import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageSnackbarComponent } from '@core/components/message-snackbar/message-snackbar.component';
import { MessageType } from '@core/enums/message-type.enum';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private snackBar: MatSnackBar) {}
  private showSnackBarMessage = (message: string, type: number) => {
    return this.snackBar.openFromComponent(MessageSnackbarComponent, {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      data: {
        title: null,
        message: message,
        icon: this.getAlertIconUrl(type),
        panelClass: this.getpanelClass(type),
      },
    });
  };

  private getpanelClass = (messageType: number): string => {
    switch (messageType) {
      case MessageType.Success:
        return 'success';
      case MessageType.Error:
        return 'error';
      case MessageType.Warning:
        return 'warn';
      case MessageType.Info:
        return 'info';
      default:
        return '';
    }
  };

  getAlertIconUrl = (messageType: number): string => {
    switch (messageType) {
      case MessageType.Success:
        return './assets/images/ic-snackbar-success.svg';
      case MessageType.Error:
        return './assets/images/ic-snackbar-error.svg';
      case MessageType.Warning:
        return './assets/images/ic-snackbar-warn.svg';
      case MessageType.Info:
        return './assets/images/ic-snackbar-info.svg';
      default:
        return '';
    }
  };

  showMessage = (message: string, type: number) => {
    this.showSnackBarMessage(message, type);
  };
}
